<template>
  <v-container
    id="line-official-account-create-old"
    class="fill-height justify-center"
  >
    <img
      class="_bench-banner _ps-fixed"
      src="/img/account/bench-banner.jpg"
      loading="lazy"
      alt="Bench Banner Image"
    />
    <v-row
      align-content="center"
      justify="center">
      <v-col lg="8">
        <v-card class="d-flex flex-column justify-center pa-10">
          <div class="d-flex flex-column align-center">
            <account-back-button
              :to="{ name: 'LineOfficialAccountCreate' }"
            ></account-back-button>
            <div class="text-center _fs-24 _fs-sm-36">
              ลูกค้าปัจจุบัน
            </div>
            <div class="d-flex flex-column _pt-40 _pt-sm-80">
              <div class="text-center">
                กรุณากรอกข้อมูล Basic ID
                <div class="primary--text">
                  (วิธีดู Basic ID ใน
                  <base-basic-id-instruction-dialog
                    v-model="pcDialog"
                    type="pc"
                  >
                    <template #default="{ on, attrs }">
                      <a
                        href="#"
                        v-bind="attrs"
                        v-on="on"> PC</a>
                    </template>
                  </base-basic-id-instruction-dialog>
                  และ
                  <base-basic-id-instruction-dialog
                    v-model="mobileDialog"
                    type="mobile"
                  >
                    <template #default="{ on, attrs }">
                      <a
                        href="#"
                        v-bind="attrs"
                        v-on="on"> มือถือ</a>
                    </template>
                  </base-basic-id-instruction-dialog
                  >)
                </div>
              </div>
              <validation-observer v-slot="{ passed }">
                <form>
                  <!-- <validation-provider
            v-slot="{ errors }"
            rules="required|digits:13"
            name="เลขประจำตัวประชาชน/เลขประจำตัวผู้เสียภาษี">
            <base-text-field
              v-model="citizenId"
              type="tel"
              maxlength="13"
              class="mt-4"
              rounded
              filled
              placeholder="ระบุ เลขประจำตัวประชาชน/เลขประจำตัวผู้เสียภาษี"
              :error-messages="errors" />
          </validation-provider> -->

                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{
                      required: true,
                      startWithAt: true,
                      lineBasicId: true,
                      newArrayItem: mapBasicIds,
                    }"
                    name="Basic ID"
                  >
                    <base-text-field
                      v-model="basicId"
                      class="mt-4"
                      rounded
                      filled
                      placeholder="ระบุ Basic ID"
                      :error-messages="errors"
                    />
                  </validation-provider>

                  <div class="text-center">
                    <v-btn
                      :disabled="!passed"
                      color="primary"
                      width="100"
                      rounded
                      @click="submit"
                    >
                      ตกลง
                    </v-btn>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import configuration from '@/config'

export default {
  name: 'LineOfficialAccountCreateOldPage',
  components: {
    AccountBackButton: () => import('@/components/AccountBackButton'),
    BaseBasicIdInstructionDialog: () => import('@/components/BaseBasicIdInstructionDialog'),
    BaseTextField: () => import('@/components/BaseTextField')
  },
  data () {
    return {
      basicId: '',
      citizenId: '',
      pcDialog: false,
      mobileDialog: false
    }
  },
  computed: {
    ...mapGetters({
      mapBasicIds: 'User/mapBasicIds'
    })
  },
  methods: {
    ...mapActions({
      fetchProfile: 'User/fetchProfile',
      createLineOfficialAccounts: 'User/createLineOfficialAccounts'
    }),
    ...mapWaitingActions('User', {
      fetchProfile: 'app loading',
      createLineOfficialAccounts: 'app loading'
    }),
    async submit () {
      try {
        await this.createLineOfficialAccounts({
          basicId: this.basicId
        })
        await this.fetchProfile()

        await this.$swal({
          title: 'ดำเนินการเรียบร้อย',
          html: `เพิ่มรับข้อมูลข่าวสาร<br>อัพเดตสถานะการสั่งซื้อ<br>กด Add LINE : ${configuration.CHATBOT_BASIC_ID}`,
          icon: 'success'
        })

        this.$router.push({ name: 'LineOfficialAccountChoose' })
      } catch {
        this.$swal({
          title: 'ไม่พบ Basic ID นี้ในระบบ<br>หรือ<br>ไม่พบสิทธิ์การใช้งานในบัญชีนี้',
          html: 'กรุณาตรวจสอบข้อมูลให้ถูกต้อง หรือติดต่อเจ้าหน้าที่<br><b>LINE : @linebysellsuki</b>',
          icon: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
._bench-banner {
  width: 100%;
  bottom: 0;

  @media only screen and (min-width: 1264px) {
    width: calc(100% - 220px);
    left: 220px;
    bottom: 10%;
  }
}
</style>
